import React from "react";
import { Link } from "react-router-dom";
//
import logo from "../../../assets/logo/logo2.png";
//
import { FaUserAlt } from "react-icons/fa";
import { FaHandsHelping, FaClipboardList } from "react-icons/fa";
import { FaDeleteLeft } from "react-icons/fa6";
import { RiLockPasswordFill } from "react-icons/ri";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const MenuPhone = ({ viewSee }) => {
  const navigate = useNavigate();

  const changeviewprov = (e, page) => {
    e.preventDefault();
    viewSee(page);
  };

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("adminType");
    sessionStorage.removeItem("Data");
    navigate("/");
  };

  return (
    <div className="boxphonemenucel">
      <div>
        <div className="boxlogophonemenu">
          <img src={logo} alt="logo" />
        </div>
        <div className="flexbuttonsphone">
          <div
            className="buttonsphone"
            onClick={(e) => changeviewprov(e, "Perfil")}
          >
            <p className="textcel">
              <FaUserAlt className="phoneicon" />
              Perfil
            </p>
          </div>
          <div
            className="buttonsphone"
            onClick={(e) => changeviewprov(e, "Factura")}
          >
            <p className="textcel">
              <FaHandsHelping className="phoneicon" />
              Subir factura
            </p>
          </div>
        </div>

        <div className="flexbuttonsphone">
          <Link to="/portal-proveedor/mis-facturas">
            <div className="boxbuttonprov">
              <p className="letterbuttonprov">
                <FaClipboardList className="iconprov" />
                Mis facturas
              </p>
            </div>
          </Link>
        </div>

        <div className="flexbuttonsphone">
          <div className="buttonsphone buttonfinal">
            <p className="textcel">
              <RiLockPasswordFill className="phoneicon" />
              Cambiar <br /> contraseña
            </p>
          </div>
        </div>
        <div className="flexbuttonsphone">
          <div className="buttonsphone buttonfinal" onClick={handleLogout}>
            <p className="textcel">
              <FaDeleteLeft className="phoneicon" />
              Salir
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuPhone;
